<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9 1C9 0.447715 8.55228 0 8 0C7.44772 0 7 0.447715 7 1V8.58579L4.70711 6.29289C4.31658 5.90237 3.68342 5.90237 3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071L12.7071 7.70711C13.0976 7.31658 13.0976 6.68342 12.7071 6.29289C12.3166 5.90237 11.6834 5.90237 11.2929 6.29289L9 8.58579V1ZM2 14C0.895431 14 0 14.8954 0 16H16C16 14.8954 15.1046 14 14 14H2Z"
  />
</template>
